import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { ApiService } from 'src/app/api.service';
import { FunctionsService } from 'src/app/services/functions.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppConstants } from 'src/app/app.constants';

@Component({
    selector: 'app-agent-dispatch-configuration',
    templateUrl: './agent-dispatch-configuration.component.html',
    styleUrls: ['./agent-dispatch-configuration.component.css'],
})

export class AgentDispatchConfigurationComponent implements OnInit {
    formSubmitted: boolean = false;
    editing: boolean = false;

    constructor(
        public functionsService: FunctionsService,
        private formBuilder: UntypedFormBuilder,
        private apiService: ApiService,
        public spinner: NgxSpinnerService) { 
            this.functionsService.setTitle('setting.agent_dispatch_configuration');
        }
        agentDispatchConfigurationForm = this.formBuilder.group({
                DispatchRatio: new UntypedFormControl('', Validators.compose([
                    Validators.required,
                    Validators.pattern(AppConstants.numberRangeRegex)
                ])),
                AttendRejectTime: new UntypedFormControl('', Validators.compose([
                    Validators.required,
                    Validators.pattern(AppConstants.secondsRangeRegex)
                ]))
          });

    ngOnInit(){
        this.validations();
        this.getAgentDispatchConfiguration();
    }

    getAgentDispatchConfiguration(){
        this.spinner.show();
        this.apiService.getAgentDispatchConfiguration().subscribe(
            data => {
                    
                this.agentDispatchConfigurationForm.controls['DispatchRatio'].setValue(data["dispatchRatio"]? data["dispatchRatio"] : '100');
                
                this.agentDispatchConfigurationForm.controls['AttendRejectTime'].setValue(data["attendRejectTime"]? data["attendRejectTime"]: '15');
                
                this.spinner.hide();
            },
            error => {this.spinner.hide();}
        );
    }

    setAgentDispatchConfiguration(){
        if (!this.agentDispatchConfigurationForm.valid) {
            this.formSubmitted = true;
            return;
        }
        this.spinner.show();
        this.apiService.setAgentDispatchConfiguration(this.agentDispatchConfigurationForm.value).subscribe(
            data => {
                this.edit();
                this.getAgentDispatchConfiguration();
            },
            error => {this.spinner.hide();}
        );
    }

    edit(){
        this.editing = !this.editing;
        if(!this.editing){
            this.agentDispatchConfigurationForm.controls['DispatchRatio'].disable();
            this.agentDispatchConfigurationForm.controls['AttendRejectTime'].disable();
            this.getAgentDispatchConfiguration();
        } else {
            this.agentDispatchConfigurationForm.controls['DispatchRatio'].enable();
            this.agentDispatchConfigurationForm.controls['AttendRejectTime'].enable();
            this.getAgentDispatchConfiguration();         
        }
    }

    validations(){
        var invalidChars = ["-", "+", "e", "."];

        var ratio = document.getElementById("DispatchRatio");
        this.agentDispatchConfigurationForm.controls['DispatchRatio'].disable();

        ratio.addEventListener("keydown", function(e) {
        if (invalidChars.includes(e.key)) {
                e.preventDefault();
            }
        });

        var timer = document.getElementById("AttendRejectTime");
        this.agentDispatchConfigurationForm.controls['AttendRejectTime'].disable();

        timer.addEventListener("keydown", function(e) {
        if (invalidChars.includes(e.key)) {
                e.preventDefault();
            }
        });
    }

    get DispatchRatio() { return this.controlGetter('DispatchRatio'); }
    get AttendRejectTime() { return this.controlGetter('AttendRejectTime'); }

    controlGetter(controlName) {
        const control =  this.agentDispatchConfigurationForm.get(controlName);
        return control && (control.touched || this.formSubmitted) ? control : {};
    }
}